export default "assets/example-space.png"